import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Grid, Icon, Dropdown } from "semantic-ui-react";
import { uid } from "uid";
import "./NewPDF.css";
import { addAgreement } from "../../store/actions/newSignup";
const NewPDF = ({ callClose }) => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [name, setName] = useState(null);
  const [agreementType, setAgreementType] = useState(null);
  const dispatch = useDispatch();

  const handleOnChange = (data) => {
    switch (data.name) {
      case "agreement type":
        setAgreementType(data.value);
        setError(null);
        break;
      default: {
      }
    }
  };
  const handleFileChange = (data) => {
    if (data && data.type === "application/pdf") {
      setFile(data);
      setName(String(data.name));
      setError(null);
    } else {
      setError("Only PDF allowed");
    }
  };
  const handleSubmit = () => {
    const data = {};
    if (name && file && agreementType && !error) {
      data.agreementId = uid(8);
      data.fileName = name;
      data.file = file;
      data.type = agreementType;
      data.show = false;
      dispatch(addAgreement(data));
      setName(null);
      setFile(null);
      setAgreementType(null);
      setError(null);
      callClose();
    } else {
      setError("All fields are required");
    }
  };

  return (
    <div className="">
      {error && <p style={{ color: "#800000" }}>{error}</p>}

      <Grid divided="vertically">
        <Grid.Row stackable="true">
          <Grid.Column mobile={16} tablet={16} computer={16} className="mb-0">
            <div className="form-group cu-form-groups">
              <label htmlFor="tarvelteam">
                Agreement Type <span className="required">*</span>
              </label>
              <Dropdown
                selection
                fluid
                onChange={(not, data) => {
                  handleOnChange(data);
                }}
                placeholder="Select Type"
                name="agreement type"
                options={[
                  {
                    key: 1,
                    text: "Main Agreement",
                    value: "main",
                  },
                  {
                    key: 2,
                    text: "Student Athlete",
                    value: "athlete",
                  },
                  {
                    key: 3,
                    text: "College Transfer",
                    value: "transfer",
                  },
                ]}
              />
              <input
                type="file"
                className="file-hidden"
                id="uploadDoc"
                accept="application/pdf"
                name="getpdf"
                hidden
                onChange={(e) => {
                  handleFileChange(e.target.files[0]);
                }}
              />
              {name && (
                <p className="dummy-text-name">
                  <Icon name="file pdf outline" /> {name}
                </p>
              )}
            </div>
          </Grid.Column>
          <Grid.Column
            mobile={16}
            tablet={16}
            computer={16}
            className="cu-center mb-0"
          >
            <div className="btn-box-data">
              <label
                htmlFor="uploadDoc"
                className="btn-cu ui green button btn-cu circular button"
              >
                <Icon name="upload" />
                Upload PDF
              </label>
              <Button
                className="saveCubutton"
                content="Save"
                disabled={error ? true : false}
                circular
                color="teal"
                onClick={handleSubmit}
              />
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default NewPDF;
